<div class="container for_school_user">
  <div class="row  align-items-center login-font flex-res r-form">
    <div class="card">
      <div class="row align-items-center">
        <div class="col-md-12 col-lg-6 p-0 rounded-0 border-0 login_background_image">
          <div class="d-flex position-relative">
            <img alt="" class="img-fluid w-100" src="../../../../assets/images/favicon/Group 1000001671.png" />
            <div class="position-absolute w-100 card-text-white">
              <div class="card-body login-content">
                <p class="join_hub">
                  <span class="hub">The ultimate hub</span> for jobs and bookings in
                  education
                </p>
                <div class="d-flex mt-20">
                  <p class="txt-regular fs-16 class-txt">New to ClassCover?</p>
                  <a class="text-regular-medium fs-16  u_l  class-txt  ml-5"
                    href="https://www.classcover.com.au/lets-make-sure-you-are-in-the-right-place/">
                    <b>Get started</b>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="">
            <div class="register-form">
              <div class="px-0 pt-5 mb-4 ">

                <p class="text-center">
                  <img alt="" class="r_image" src="assets/images/side-nav/cc_original@2x.png">
                </p>
                <ul id="progress-bar" class="px-0 mt-30 mb-100"
                  [ngClass]="!hideBasicInfos ? 'progressbar' : 'progressbar_c'">
                  <li [ngClass]="!hideBasicInfos ? 'one_active' : ''" class="">Basic information</li>
                  <li [ngClass]="hideBasicInfos ? 'two_active' : ''">Create password</li>
                </ul>
                @if (!hideBasicInfos) {
                <div>
                  <form [formGroup]="BasicInformationForm" autocomplete="off">
                    <div class="row px-0 mt-30">
                      <div class="col-lg-12">
                        <label for="are_you_part" id="are_you_part_label">Are you part of a school or education
                          business?</label>
                        <ng-select id="are_you_part" aria-labelledby="are_you_part_label"
                          ariaLabel="Are you part of a school or education business" [searchable]="false"
                          [clearable]="false" [dropdownPosition]="'bottom'" [multiple]="false" type="text"
                          formControlName="organization_type" class="cc-center-select">
                          <ng-option value="">Select organisation type</ng-option>
                          <ng-option value="school">School</ng-option>
                          <ng-option value="company">Education Business</ng-option>
                        </ng-select>
                        @if (submittedBasic) {
                        <div>
                          @if (b['organization_type'].errors?.['required'] ||
                          b['organization_type'].errors?.['whitespace'])
                          {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-12 mt-10">
                        <label for="name_of_school" id="name_of_school_label">Name of School/Company</label>
                        <input autocomplete="off" id="name_of_school" aria-labelledby="name_of_school_label"
                          ariaLabel="Name of School/Company" type="text" class="form-control"
                          formControlName="school_name">
                        @if (submittedBasic) {
                        <div>
                          @if (b['school_name'].errors?.['required'] || b['school_name'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-6 mt-10 ">
                        <label for="street" id="street_label">Street number</label>
                        <input id="street" aria-labelledby="street_label" ariaLabel="Street number" autocomplete="off"
                          type="text" class="form-control" formControlName="street_number">
                        @if (submittedBasic) {
                        <div>
                          @if (b['street_number'].errors?.['required'] || b['street_number'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-6 mt-10">
                        <label for="street_name" id="street_name_label">Street name</label>
                        <input id="street_name" aria-labelledby="street_name_label" ariaLabel="Street name"
                          autocomplete="off" type="text" class="form-control" formControlName="street_name">
                        @if (submittedBasic) {
                        <div>
                          @if (b['street_name'].errors?.['required'] || b['street_name'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-12 mt-10">
                        <label for="state" id="state_label">State</label>
                        <ng-select id="state" aria-labelledby="state_label" ariaLabel="State" [searchable]="false"
                          [clearable]="false" [dropdownPosition]="'bottom'" [multiple]="false" type="text"
                          formControlName="state" class="cc-center-select">
                          <ng-option value="">Select state</ng-option>
                          <ng-option value="Australian Capital Territory">Australian Capital
                            Territory</ng-option>
                          <ng-option value="New South Wales">New South Wales</ng-option>
                          <ng-option value="Northern Territory">Northern Territory</ng-option>
                          <ng-option value="Queensland">Queensland</ng-option>
                          <ng-option value="South Australia">South Australia</ng-option>
                          <ng-option value="Tasmania">Tasmania</ng-option>
                          <ng-option value="Victoria">Victoria</ng-option>
                          <ng-option value="Western Australia">Western Australia</ng-option>
                        </ng-select>
                        @if (submittedBasic) {
                        <div>
                          @if (b['state'].errors?.['required'] || b['state'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-6 mt-10">
                        <label for="city_suburb" id="city_suburb_label">City or suburb</label>
                        <input id="city_suburb" aria-labelledby="city_suburb_label" ariaLabel="City or suburb"
                          autocomplete="off" type="text" class="form-control" formControlName="city">
                        @if (submittedBasic) {
                        <div>
                          @if (b['city'].errors?.['required'] || b['city'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-6 mt-10">
                        <label for="postcode" id="postcode_label">Postcode</label>
                        <input id="postcode" aria-labelledby="postcode_label" ariaLabel="Postcode" autocomplete="off"
                          type="text" class="form-control" formControlName="postal_code">
                        @if (submittedBasic) {
                        <div>
                          @if (b['postal_code'].errors?.['required'] || b['postal_code'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-12 mt-20">
                        <button ariaLabel="Next nav to create password" (click)="hideBasicInfo()"
                          class="btn cc_p_btn btn_w">Next</button>
                      </div>
                    </div>
                  </form>
                </div>
                }
                @if (hideBasicInfos) {
                <div>
                  <form [formGroup]="otherInformationForm" autocomplete="off">
                    <div class="row px-0 mt-30">
                      <div class="col-lg-12 mt-10">
                        <label for="fullname" id="fullname_label">Full name</label>
                        <input id="fullname" aria-labelledby="fullname_label" ariaLabel="Full name" autocomplete="off"
                          type="text" class="form-control" formControlName="full_name">
                        @if (submittedOther) {
                        <div>
                          @if (o['full_name'].errors?.['required'] || o['full_name'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-12 mt-10">
                        <label for="phone_number" id="phone_number_label">Phone number</label>
                        <input id="phone_number" aria-labelledby="phone_number_label" ariaLabel="Phone number"
                          autocomplete="off" type="text" class="form-control" formControlName="phone_no">
                        @if (submittedOther) {
                        <div>
                          @if (o['phone_no'].errors?.['required'] || o['phone_no'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-12 mt-10">
                        <label for="email" id="email_label">Email</label>
                        <input id="email" aria-labelledby="email_label" ariaLabel="Email" autocomplete="off" type="text"
                          class="form-control" formControlName="user_email">
                        @if (submittedOther) {
                        <div>
                          @if (o['user_email'].errors?.['required'] || o['user_email'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-12 mt-10">
                        <label for="create_password" id="create_password_label">Create password</label>
                        <input id="create_password" aria-labelledby="create_password_label" ariaLabel="Create password"
                          autocomplete="off" type="password" class="form-control" formControlName="password">
                        @if (submittedOther) {
                        <div>
                          @if (o['password'].errors?.['required'] || o['password'].errors?.['whitespace']) {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                      </div>
                      <div class="col-lg-12 mt-10">
                        <label for="retype_password" id="retype_password_label">Retype password</label>
                        <input id="retype_password" aria-labelledby="retype_password_label" ariaLabel="Retype password"
                          autocomplete="off" (keyup)="makePasswordFalse()" type="password" class="form-control"
                          formControlName="confirm_password">
                        @if (submittedOther) {
                        <div>
                          @if (o['confirm_password'].errors?.['required'] ||
                          o['confirm_password'].errors?.['whitespace'])
                          {
                          <span class="show-errors">*
                            This field is required</span>
                          }
                        </div>
                        }
                        @if (!passwordMatch) {
                        <span class="show-errors">
                          Password does not match</span>
                        }
                      </div>
                      <div class="row mt-10">
                        <div class="col-lg-12">
                          <div class="d-flex">
                            <div>
                              <input id="checkBox" aria-labelledby="checkBox_label" role="checkbox"
                                ariaLabel="Retype password" (change)="checkCondition($event)" class="form-check-input"
                                type="checkbox" />
                            </div>
                            <div>
                              <label for="checkBox" id="checkBox_label" class="ml-5 txt-regular m-0 mt-4">I agree to the
                                <a class="reg-Link clr-cc-vilot text-regular-bold" target="_blank"
                                  href="https://www.classcover.com.au/terms-and-conditions/">Terms and Conditions</a>
                                and
                                <a class="reg-Link clr-cc-vilot text-regular-bold" target="_blank"
                                  href="https://www.classcover.com.au/privacy-policy/">Privacy Policy</a>.</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12 mt-10">
                        <a role="button" ariaLabel="Back to basic information" (click)="hideOtherInfo()"
                          class="text-regular-medium clr-cc-vilot c-p focusclickable"><i class="bi bi-chevron-left"></i>
                          Back</a>
                      </div>
                      <div class="col-lg-12 mt-10">
                        <button (click)="submitRegistration()" ariaLabel="Get started" class="btn cc_p_btn btn_w">Start
                          with the free trial</button>
                      </div>
                    </div>
                  </form>
                </div>
                }
                <hr class="mt-20 mb-20">
                <div class="col-lg-12 mt-5 text-center">
                  <!-- <p class="txt-regular clr-grey-3 c-p" (click)="openRequestAccessModal()">Does your school or
                                  organisation already have a
                                  ClassCover Jobs account?<span class="text-regular-medium clr-cc-vilot c-p"> Request
                                access</span></p> -->

                  <p class="txt-regular clr-grey-3 c-p">Already have an account? <span routerLink="/"
                      class="text-regular-medium clr-cc-vilot c-p">Login</span></p>
                </div>
                <div class="col-lg-12 mt-5 text-center">
                  <p class="text-regular-medium"> or</p>
                </div>
                <div class="col-lg-12 mt-5 text-center">
                  <p class="txt-regular clr-grey-3 c-p" (click)="openRequestAccessModal()">Join an existing
                    account <span class="text-regular-medium clr-cc-vilot c-p"> Request
                      access</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <ng-template #cancelReasonModal>
      <form [formGroup]="cancelBookingRequestForm" class="">
        <div class="modal-header">
          <h4 class="modal-title" id="exampleModalLabel">Request access to be added to your school’s
            ClassCover account</h4>
          <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
        </div>

        <div class="modal-body pb-0">
          <div class="row  align-items-center">
            <div class="col-lg-12 mt-10">
              <label>School <span class="mandatory">*</span></label>
              <ng-select [searchable]="true" [clearable]="false" [dropdownPosition]="'bottom'" [multiple]="false"
                type="text" formControlName="school_id" class="cc-center-select" placeholder="Select state">
                <ng-option value="">Select school</ng-option>
                @for (list of filtersArray.school_list; track list) {
                <ng-option value="{{list.school_id}}">{{list.school_name}}</ng-option>
                }
              </ng-select>
              @if (submitted) {
              <div>
                @if (a['school_id'].errors?.['required'] || a['school_id'].errors?.['whitespace']) {
                <span class="show-errors">*
                  This field is required</span>
                }
              </div>
              }
            </div>
            <div class="col-lg-12 mt-10">
              <label>Name <span class="mandatory">*</span></label>
              <input autocomplete="off" type="text" class="form-control" formControlName="user_name"
                placeholder="Type here">
              @if (submitted) {
              <div>
                @if (a['user_name'].errors?.['required'] || a['user_name'].errors?.['whitespace']) {
                <span class="show-errors">*
                  This field is required</span>
                }
              </div>
              }
            </div>
            <div class="col-lg-12 mt-10">
              <label>Email <span class="mandatory">*</span></label>
              <input autocomplete="off" type="text" class="form-control" formControlName="user_email"
                placeholder="Enter email">
              @if (submitted) {
              <div>
                @if (a['user_email'].errors?.['required'] || a['user_email'].errors?.['whitespace']) {
                <span class="show-errors">*
                  This field is required</span>
                }
              </div>
              }
            </div>
          </div>
        </div>

        <div class="modal-footer mt-10">
          <button type="button" (click)="submit_access()" class="btn cc_p_btn fs_13">Submit</button>
        </div>
      </form>
    </ng-template>
  </div>
</div>